import { useTranslation } from 'react-i18next';
import MainTitle from '../common/MainTitle';
import Icon from '../common/Icon';

import ImageLink from '../../js/utils/ImageLink';

export default function HeroSection({ image1, image2 }) {
  const { t } = useTranslation(['NewsPage']);

  return (
    <section className="news-hero-section container">
      <MainTitle type="dark" className="text--2xl hidden--lg">
        <span>{t('title1')}</span>
        <span className="decorated-line decorated-line--dark decorated-line--left">
          {t('title2')}
        </span>
      </MainTitle>
      {image1 && (
        <div className="news-hero-section__main-media">
          <picture>
            <source srcSet={ImageLink(image1.url)} type="image/webp" />
            <img src={ImageLink(image1.url)} alt={image1?.alt} />
          </picture>
        </div>
      )}

      <div className="news-hero-section__content">
        <div className="news-hero-section__content-container">
          <MainTitle type="dark" className="text--2xl hidden--md">
            <span>{t('title1')}</span>
            <span className="decorated-line decorated-line--dark decorated-line--left">
              {t('title2')}
            </span>
          </MainTitle>

          <p className="news-hero-section__description">{t('subtitle')}</p>
        </div>
        {image2 && (
          <div className="news-hero-section__secondary-media">
            <picture>
              <source srcSet={ImageLink(image2.url)} type="image/webp" />
              <img src={ImageLink(image2.url)} alt={image2?.alt} />
            </picture>
          </div>
        )}
      </div>
      <Icon name="spiral-arrow-down" className="spiral-arrow-icon" />
    </section>
  );
}
